export default __webpack_public_path__ + "static/media/MTN.ca4477ed.svg";